import { render, staticRenderFns } from "./ProfileSection.vue?vue&type=template&id=4c49be15&"
import script from "./ProfileSection.vue?vue&type=script&lang=ts&"
export * from "./ProfileSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports